import { useEffect } from 'react'
import * as OfflinePluginRuntime from 'offline-plugin/runtime'
// @ts-ignore
import lifecycle from 'page-lifecycle'

export default function UpdateChecker(): JSX.Element {
  useEffect(() => {
    OfflinePluginRuntime.update()

    const onStateChange = (event: any) => {
      try {
        const lastUpdateCheck = JSON.parse(window.localStorage.getItem('lastUpdateCheck')) ?? 0
        const shouldCheckUpdate = Date.now() - lastUpdateCheck > 60000 // check once per minute

        if (event.newState === 'active' && shouldCheckUpdate) {
          window.localStorage.setItem('lastUpdateCheck', JSON.stringify(Date.now()))
          OfflinePluginRuntime.update()
        }
      } catch (e) {
        console.log(e)
        // An error here likely means localStorage is disabled.
        return
      }
    }

    lifecycle.addEventListener('statechange', onStateChange)

    return () => lifecycle.removeEventListener('statechange', onStateChange)
  }, [])

  return null
}
